module.exports = __webpack_public_path__ + "img/cs-table.92b2ac4f.png";